import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControlKeyLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconControlKeyLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21V3H3V21H21ZM9 6.58579L12.4142 10L11 11.4142L9 9.41421L7 11.4142L5.58579 10L9 6.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconControlKeyLeft;
